import { floatWithElement } from '@core/component/LexicalMarkdown/directive/floatWithElement';
import clickOutside from '@core/directive/clickOutside';
import { DatePickerUI } from './DatePickerUI';

false && floatWithElement;
false && clickOutside;

type DatePickerProps = {
  value: Date;
  onChange: (date: Date) => void;
  onClose: () => void;
  anchorRef: HTMLElement;
};

export function DatePicker(props: DatePickerProps) {
  return (
    <div
      class="absolute z-action-menu border border-edge-muted bg-surface font-mono text-sm"
      use:floatWithElement={{ element: () => props.anchorRef }}
      use:clickOutside={props.onClose}
    >
      <DatePickerUI value={props.value} onChange={props.onChange} />
    </div>
  );
}
